@if(showLoader) {
    <div class="text-center loading spinner">
      <div class="double-bounce1"></div>
      <div class="double-bounce2"></div>
    </div>
} @else {
  <div class="card-container">
    <div class="terminal">
      <pre>We could not find the link. Please try again.</pre>
    </div>
  </div>
}
